const bars = [
  { x: 122, y: 374, h: 525, fill: "#64748B" },
  { x: 298, y: 374, h: 68, fill: "#0D9488" },
  { x: 474, y: 442, h: 14, fill: "#D97706" },
  { x: 651, y: 456, h: 82, fill: "#11CAA0" },
  { x: 827, y: 538, h: 41, fill: "#3B82F6" },
  { x: 1003, y: 579, h: 32, fill: "#A855F7" },
  { x: 1179, y: 611, h: 23, fill: "#10B981" },
  { x: 1356, y: 634, h: 23, fill: "#881337" },
  { x: 1532, y: 374, h: 283, fill: "#F87171" },
  { x: 1708, y: 657, h: 242, fill: "#DEFF9A" },
];

const values = [
  { cx: 167, y: 361, t: "$11.5M" },
  { cx: 343, y: 361, t: "-$1.5M" },
  { cx: 519, y: 429, t: "-$0.3M" },
  { cx: 696, y: 443, t: "-$1.8M" },
  { cx: 872, y: 525, t: "-$0.9M" },
  { cx: 1048, y: 566, t: "-$0.7M" },
  { cx: 1224, y: 598, t: "-$0.5M" },
  { cx: 1401, y: 621, t: "-$0.5M" },
  { cx: 1577, y: 361, t: "$6.2M", bold: true },
  { cx: 1753, y: 644, t: "$5.3M" },
];

const labels = [
  { cx: 167, y: 972, lines: ["Trapped Working", "Capital"] },
  { cx: 343, y: 989, lines: ["AR vs AP"] },
  { cx: 519, y: 989, lines: ["Invoicing Lag"] },
  { cx: 696, y: 989, lines: ["Collection Gap"] },
  { cx: 872, y: 972, lines: ["Inventory", "Inefficiency"] },
  { cx: 1048, y: 989, lines: ["Data Friction"] },
  { cx: 1224, y: 989, lines: ["Absorption Bloat"] },
  { cx: 1401, y: 989, lines: ["Obsolete Purge"] },
  { cx: 1577, y: 972, lines: ["Saving", "Opportunity"] },
  { cx: 1753, y: 972, lines: ["Targeted Working", "Capital"] },
];

const SANS = "Inter, Manrope, sans-serif";

export const Waterfall = () => (
  <div data-testid="waterfall-chart" className="mt-10 rounded-xl border border-white/15 overflow-hidden">
    <svg
      viewBox="0 0 1920 1080"
      className="w-full h-auto block"
      role="img"
      aria-label="The cash-tied-up waterfall: from $11.5M trapped working capital to a $5.33M target"
    >
      <image href="/images/waterfall-bg.png" x="0" y="0" width="1920" height="1080" preserveAspectRatio="none" />
      <text x="118" y="235" fill="#F2EEE4" fontSize="88" fontFamily="Georgia, 'Times New Roman', serif">
        The cash-tied-up waterfall
      </text>
      <text x="122" y="305" fill="#93A2A8" fontSize="37" fontFamily={`'Helvetica Neue', ${SANS}`}>
        From operational cash roadmap to trapped working capital to a defensible target
      </text>
      {bars.map((b, i) => (
        <rect key={i} x={b.x} y={b.y} width="90" height={b.h} fill={b.fill} />
      ))}
      {values.map((v, i) => (
        <text key={i} x={v.cx} y={v.y} textAnchor="middle" fill="#CBD5E1" fontSize="27" fontWeight={v.bold ? "700" : "400"} fontFamily={SANS}>
          {v.t}
        </text>
      ))}
      {labels.map((l, i) => (
        <text key={i} x={l.cx} y={l.y} textAnchor="middle" fill="#CBD5E1" fontSize="21" fontWeight="600" fontFamily={SANS}>
          {l.lines.map((line, li) => (
            <tspan key={li} x={l.cx} dy={li === 0 ? 0 : 27}>{line}</tspan>
          ))}
        </text>
      ))}
    </svg>
  </div>
);
